$(function() {

    var prevModal;
    $(".btn-perdata").click(function(e) {
        e.preventDefault();
        if ( $(".default-modal.active").length ) {
            prevModal = $(this).closest(".default-modal");
            prevModal.removeClass("active");
            setTimeout(function() {
                $(".modal-perdata").addClass("active half");
            }, 300);
        }else{
            showModal("modal-perdata");
        }
    });
    $(".btn-confid").click(function(e) {
        e.preventDefault();
        if ( $(".default-modal.active").length ) {
            prevModal = $(this).closest(".default-modal");
            prevModal.removeClass("active");
            setTimeout(function() {
                $(".modal-confid").addClass("active half");
            }, 300);
        }else{
            showModal("modal-confid");
        }
    });
    $("[data-modal]").click(function(e) {
        e.preventDefault();
        showModal($(this).data("modal"));
    });
    function showModal(e) {
        $("body").addClass("modal-open");
        var modal = $("." + e + "");
        // var scrollTop = ($('html').scrollTop()) ? $('html').scrollTop() : $('body').scrollTop(); // Works for Chrome, Firefox, IE...
        // $('html').addClass('no-scroll').css('top',-scrollTop);
        $('html').addClass('no-scroll');
        // console.log(modal);
        if (hasScrollbar()) {
            // с учетом горизонтального скролла. Чтобы небыло рывка при открытии модального окна
            var scrollWidth = getScrollbarWidth();
            // console.log(scrollWidth);
            $("html").css({
                "margin-right": scrollWidth
            });
            modal.addClass("active");
        } else {
            modal.addClass("active");
        }

        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        if (isIE === true) {
            // console.log(modal.find(".default-modal__content").outerHeight(), $(window).height());
            // var blockPosTop = modal.find(".default-modal__content").position().top;
            // if ( blockPosTop < 0 ) {
            //     console.log(blockPosTop)
            //     modal.css("display", "block");
            // }else {
            //     modal.removeAttr("style");
            // }
            if ( modal.find(".default-modal__content").outerHeight() > $(window).height() ) {
                // console.log(blockPosTop)
                modal.css("display", "block");
            }else {
                modal.removeAttr("style");
            }
        }
    }
    $(".default-modal__close").click(function() {
        var thisModal = $(this).closest(".default-modal");
        if ( thisModal.hasClass("half") ) {
            thisModal.removeClass("active half");
            setTimeout(function() {
                prevModal.addClass("active");
            }, 300);
        }else {
            callbackClose();
        }
    });

    $(".default-modal").click(function(e) {
        var thisModal = $(this);
        if ( thisModal.hasClass("half") ) {
            thisModal.removeClass("active half");
            setTimeout(function() {
                prevModal.addClass("active");
            }, 300);
        }else{
            if (!$(e.target).closest(".default-modal__content").length) {
                callbackClose();
                e.stopPropagation();//?
            }else{
                // console.log("modal-content click");
            }
        }
    });

    document.addEventListener('keydown', function (e) {
        if(e.key==="Escape"||e.key==='Esc'||e.keyCode===27) {
            var thisModal = $(".default-modal.half");
            if ( thisModal.length ) {
                thisModal.removeClass("active half");
                setTimeout(function() {
                    prevModal.addClass("active");
                }, 300);
            }else {
                callbackClose();
            }
        }
    });
    function callbackClose() {
        $("body").removeClass("modal-open");
        $(".default-modal").removeClass("active");
        setTimeout(function() {
            var scrollTop = parseInt($('html').css('top'));
            $('html').removeClass('no-scroll');
            // $('html,body').scrollTop(-scrollTop);
            $('html').css('margin-right','');
        }, 300);
    }



});